import DOMPurify from 'dompurify';
// One allow-list for all property-authored HTML: DOMPurify defaults plus
// embedded iframes (maps, tours) and links that open in a new tab.
const SANITIZE_CONFIG = {
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    ADD_TAGS: ['iframe'],
};
// Links opening a new tab must not get a handle on this window.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute('target')) {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});
export const sanitizeHtml = (html) => DOMPurify.sanitize(html, SANITIZE_CONFIG);
